<template>
  <div :class="$style.agentAvatar">
    <div :class="$style.agentIconWrapper">
      <app-svg-icon name="ic_menu_personal_active"
                    :class="$style.agentIcon"/>
    </div>
    <div :class="$style.agentInfo">
      <h6>{{ role }}</h6>
      <router-link :to="agentLink">
        {{ name }}
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true,
    },
    id: {
      type: Number,
      required: true,
    },
    role: {
      type: String,
      required: true,
    },
  },
  computed: {
    agentLink() {
      return `/agents/${this.id}`;
    },
  },
};
</script>

<style lang="scss" module>
@import "@/styles/variables.scss";

.agentAvatar {
  display: flex;
  align-items: center;
  margin-right: 20px;
  margin-left: 20px;
}

.agentIconWrapper {
  width: 32px;
  height: 32px;
  background-color: $left-sidebar-color;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 10px;

  .agentIcon {
    width: 20px;
    height: 20px;
  }
}

.agentInfo {
  h6 {
    font-size: 1.2rem;
    line-height: 1.4rem;
    font-style: normal;
  }

  a {
    font-size: 1.2rem;
    line-height: 1.4rem;
    color: #3A82DF;
    margin-bottom: 0;
    text-decoration: none;
  }
}
</style>
